module.exports = __webpack_public_path__ + "static/media/cert_92.ae333c91.jpg";